import { useMutation, useQuery } from "convex/react";
import { useState } from "react";
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "@repo/ui";
import { api } from "@convex/_generated/api";

export function CarteProfil() {
  const user = useQuery(api.auth.currentUser);
  const modifierMonNom = useMutation(api.compte.modifierMonNom);

  // `undefined` = champ jamais touché → on affiche la valeur serveur. Évite le
  // `useEffect` de synchronisation que la convention du repo proscrit pour une
  // donnée dérivable au render.
  const [saisie, setSaisie] = useState<string | undefined>(undefined);
  const [etat, setEtat] = useState<
    { type: "idle" } | { type: "envoi" } | { type: "ok" } | { type: "ko"; message: string }
  >({ type: "idle" });

  const nom = saisie ?? user?.name ?? "";
  const inchange = nom.trim() === (user?.name ?? "").trim();

  const enregistrer = async (e: React.FormEvent) => {
    e.preventDefault();
    setEtat({ type: "envoi" });
    try {
      await modifierMonNom({ nom });
      setSaisie(undefined);
      setEtat({ type: "ok" });
    } catch (err) {
      setEtat({
        type: "ko",
        message: err instanceof Error ? err.message : "Erreur inconnue",
      });
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Profil</CardTitle>
        <CardDescription>
          Votre adresse email sert d'identifiant de connexion et n'est pas
          modifiable ici.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={(e) => void enregistrer(e)} className="space-y-4">
          <div>
            <Label htmlFor="profil-email" className="mb-1">
              Email
            </Label>
            <Input id="profil-email" value={user?.email ?? ""} disabled />
          </div>
          <div>
            <Label htmlFor="profil-nom" className="mb-1">
              Nom affiché
            </Label>
            <Input
              id="profil-nom"
              value={nom}
              onChange={(e) => {
                setSaisie(e.target.value);
                setEtat({ type: "idle" });
              }}
              maxLength={100}
            />
          </div>

          {etat.type === "ko" && (
            <p className="text-sm text-destructive">{etat.message}</p>
          )}
          {etat.type === "ok" && (
            <p className="text-sm text-muted-foreground">Nom enregistré.</p>
          )}

          <div className="flex justify-end">
            <Button
              type="submit"
              disabled={etat.type === "envoi" || inchange || nom.trim() === ""}
            >
              {etat.type === "envoi" ? "Enregistrement…" : "Enregistrer"}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
